import styled from 'styled-components';
import { color, compose, space, typography } from 'styled-system';

const SVGSystem = compose(color, space, typography);

export default (icon: React.ComponentType<SVGAttrs>) => styled(icon)(SVGSystem);
